import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import Download from '@/pages/Download'
import PasswordRecovery from '@/pages/PasswordRecovery'
import RequestAccess from '@/pages/RequestAccess'
import cookies from 'vue-js-cookie'
import Store from '@/store'
import i18n from '@/languages';
import AppHelper from "../helper";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    saveScrollPosition: true,
    routes: [
        {
            path: '/home',
            component: Home,
        },
        {
            path: '/home/:key',
            name: 'Home',
            meta: {
                title: i18n.t('LBL_HOME_PAGE')
            },
            component: Home,
            beforeEnter: (to, from, next) => {
                if(!AppHelper.empty(to.params.key)){
                    cookies.set('instance', to.params.key, 365)
                }

                if(!Api.isAuthenticated()){
                    next({name: 'Login'})
                }

                next()
            }
        },
        {
            path: '/login',
            name:  'Login',
            meta: {
                title: i18n.t('LBL_LOGIN_PAGE')
            },
            component:  Login
        },
        {
            path: '/passwordrecovery',
            name: 'PasswordRecovery',
            meta: {
                title: i18n.t('LBL_PASSWORD_RECOVERY_PAGE')
            },
            component: PasswordRecovery
        },
        {
            path: '/requestaccess',
            name: 'RequestAccess',
            meta: {
                title: i18n.t('LBL_REQUEST_ACCESS_PAGE')
            },
            component: RequestAccess
        },
        {
            path: '/download/:key/:file',
            name: 'Download',
            meta: {
                title: i18n.t('LBL_DOWNLOAD_PAGE')
            },
            component: Download,
            beforeEnter: (to, from, next) => {
                if(!AppHelper.empty(to.params.key)){
                    cookies.set('instance', to.params.key, 365)
                }

                if(!Api.isAuthenticated()){
                    Store.commit('setRedirect', to)
                    next({name: 'Login'})
                }

                next()
            }
        },
        {
            path: '/:key',
            redirect: {name: 'Home'},
        },
        {
            path: '*',
            redirect: {path: '/home/ '}
        }
    ],
})

router.beforeEach((to, from, next) => {
    var titles = [i18n.t('LBL_GDPR_PORTAL')]

    if(!AppHelper.empty(to.meta.title)){
        titles.push(to.meta.title)
    }

    document.title = titles.join(' - ')

    next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js